import { render, staticRenderFns } from "./waiting-payment.vue?vue&type=template&id=fb82b002&scoped=true"
import script from "./waiting-payment.vue?vue&type=script&lang=js"
export * from "./waiting-payment.vue?vue&type=script&lang=js"
import style0 from "./waiting-payment.vue?vue&type=style&index=0&id=fb82b002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb82b002",
  null
  
)

export default component.exports